import React from 'react';
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';
import { TableColumn } from 'react-data-table-component';
import CustomMaterialMenu from '../../Component/DataGrid/Plugins/CustomMaterialMenu/CustomMaterialMenu';
import { IUserReport, UserReportsProps, UserReportsState } from './Interface';
import DataGrid from '../../Component/DataGrid/DataGrid';
import LimitHistoryTable from './ReportsMenu/LimitHistory';
import ReportService from '../../Services/ReportService'
import '../UserDetails/UserDetails.css';
import { formatLimit, convertToNumber } from '../../Component/config';
import { SyncContext, SyncContextType } from '../../Contexts/BatchSyncContext';
import UserAndPermissionService from '../../Services/UserAndPermissionService';
import moment from 'moment';

class UserReports extends React.Component<UserReportsProps, UserReportsState> {
    static contextType = SyncContext;
    context!: SyncContextType;
    private tableColumns: TableColumn<IUserReport>[] = [
        {
            name: 'User ID',
            selector: row => row.userId,
            sortable: false,
            omit: true
        },
        {
            name: 'User Name',
            selector: row => row.userName ? row.userName : "Nill....",
            sortable: true,
            id: "userName",
            wrap: true,
            minWidth: "250px",
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
            minWidth: "200px",
            wrap: true,
            id: "email",

        },
        {
            name: 'Biometric',
            selector: row => row.isBiometric ? "Yes" : "No",
            sortable: true,
            id: "isBiometric",
            center: true,
            wrap: true,
        },
        {
            name: 'Total TransValue',
            selector: row => formatLimit(row.totalTransaction, "en-US", "USD", "$"),
            sortable: true,
            id: "totalTransaction",
            right: true,
            minWidth: "150px",
            maxWidth: "200px",
            wrap: true,
        },
        // {
        //     name: 'Trans%(H)',
        //     selector: row => row.hourlyThreshold,
        //     sortable: true,
        //     id: "hourlyThreshold",
        //     cell: (row) => {
        //         const globalThreshHold = convertToNumber(row.threshold) || 80;
        //         const statusLabel = row.hourlyThreshold < globalThreshHold ? <span className='status-label active'>{row.hourlyThreshold}</span> :
        //             row.hourlyThreshold >= globalThreshHold ? <span className="status-label blocked">{row.hourlyThreshold}</span> :
        //                 <span className="status-label unknown">UNKNOWN</span>;
        //         return statusLabel;
        //     }
        // },
        {
            name: 'Threshold%(D)',
            selector: row => row.dailyThreshold,
            sortable: true,
            id: "dailyThreshold",
            cell: (row) => {
                const globalThreshHold = convertToNumber(row.threshold) || 80;
                const statusLabel = row.dailyThreshold && row.dailyThreshold < globalThreshHold ? <span className='status-label active'>{row.dailyThreshold}</span> :
                    row.dailyThreshold == null ? <span className='status-label active'>0</span> : row.dailyThreshold >= globalThreshHold ? <span className="status-label blocked">{row.dailyThreshold}</span> :
                        <span className="status-label unknown">UNKNOWN</span>;
                return statusLabel;
            },
            width: "130px",
            wrap: true,
            center: true,
        },
        {
            name: 'Threshold%(W)',
            selector: row => row.weeklyThreshold,
            sortable: true,
            id: "weeklyThreshold",
            cell: (row) => {
                const globalThreshHold = convertToNumber(row.threshold) || 80;
                const statusLabel = row.weeklyThreshold && row.weeklyThreshold < globalThreshHold ? <span className='status-label active'>{row.weeklyThreshold}</span> :
                    row.weeklyThreshold == null ? <span className='status-label active'>0</span> : row.weeklyThreshold >= globalThreshHold ? <span className="status-label blocked">{row.weeklyThreshold}</span> :
                        <span className="status-label unknown">UNKNOWN</span>;
                return statusLabel;
            },
            width: "130px",
            wrap: true,
            center: true,
        },
        {
            name: 'Threshold%(M)',
            selector: row => row.monthlyThreshold,
            sortable: true,
            id: "monthlyThreshold",
            cell: (row) => {
                const globalThreshHold = convertToNumber(row.threshold) || 80;
                const statusLabel = row.monthlyThreshold && row.monthlyThreshold < globalThreshHold ? <span className='status-label active'>{row.monthlyThreshold}</span> :
                    row.monthlyThreshold == null ? <span className='status-label active'>0</span> : row.monthlyThreshold >= globalThreshHold ? <span className="status-label blocked">{row.monthlyThreshold}</span> :
                        <span className="status-label unknown">UNKNOWN</span>;
                return statusLabel;
            },
            width: "130px",
            wrap: true,
            center: true,
        },
        {
            name: 'Threshold%(Y)',
            selector: row => row.yearlyThreshold,
            sortable: true,
            id: "yearlyThreshold",
            cell: (row) => {
                const globalThreshHold = convertToNumber(row.threshold) || 80;
                const statusLabel = row.yearlyThreshold && row.yearlyThreshold < globalThreshHold ? <span className='status-label active'>{row.yearlyThreshold}</span> :
                    row.yearlyThreshold == null ? <span className='status-label active'>0</span> : row.yearlyThreshold >= globalThreshHold ? <span className="status-label blocked">{row.yearlyThreshold}</span> :
                        <span className="status-label unknown">UNKNOWN</span>;
                return statusLabel;
            },
            width: "130px",
            wrap: true,
            center: true,
        },
        {
            name: 'Total Fees Generated',
            selector: row => formatLimit(row.totalFees, "en-US", "USD", "$"),
            sortable: true,
            id: "totalFees",
            center: true,
            minWidth: "130px",
            maxWidth: "200px",
            wrap: true,
        },
        {
            name: 'Total No. 0f Trans',
            selector: row => row.numberOfTransaction,
            sortable: true,
            id: "numberOfTransaction",
        },
        {
            name: 'Avg TransValue',
            selector: row => formatLimit(row.averageTransaction, "en-US", "USD", "$"),
            sortable: true,
            id: "averageTransaction",
            minWidth: "130px",
            maxWidth: "200px",
            wrap: true,
        },
        {
            name: 'Last Transaction',
            selector: row => moment(row.lastActivityDate).format('MM-DD-YYYY hh:mm A'),//hh:mm A on Do MMMM YYYY
            sortable: true,
            id: "lastActivityDate",
            wrap: true,
            minWidth: '160px'
        },
        {
            name: 'Actions',
            cell: row => {
                const { userTransactionReport } = this.state

                if (!userTransactionReport.isLimitHistoryVisible) return null;
                return (
                    <CustomMaterialMenu
                        fontSize="small"
                        multiPopoverItems={[
                            {
                                key: "limitHistory",
                                label: "Limit History"
                            }
                        ]}
                        onPopoverClick={(key_: string) => {
                            this.openChildComponent(row, key_);
                        }}
                        disabled={false}
                    />
                );
            },
            allowOverflow: true,
            button: true,
            width: '200px'
        }
    ]

    constructor(props_: UserReportsProps) {
        super(props_);

        this.state = {
            accessToken: "",
            userData: [],
            currentRowsPerPage: 10,
            currentPage: 1,
            totalRows: 100,
            searchText: "",
            selectedFilter: "",
            filterValue: "",
            showChildComponent: false,
            selectedKey: "",
            userID: "",
            userTransactionReport: {
                isVisible: true,
                isDownloadVisible: true,
                isLimitHistoryVisible: true,
                isLimitHistoryDownloadVisible: true,
            },
        }
    }

    async componentDidMount() {
        try {
            const accessToken_ = await loadFromLocalStorage('accessToken');
            const profile_ = await loadFromLocalStorage('profile');

            if (!accessToken_ || !profile_) {
                localStorage.clear();
                window.location.href = '/';
                return;
            }

            const accessToken = accessToken_.toString();
            const userProfile = typeof profile_ === 'string' ? JSON.parse(profile_) : profile_;

            this.setState({ accessToken }, async () => {
                try {
                    if (userProfile?.roleId) {
                        const permissionResponseRaw = await UserAndPermissionService.getPermissions(accessToken, userProfile?.roleId);
                        const permissionResponse = await permissionResponseRaw.json();

                        if (!permissionResponse?.permissions?.userTransactionReport?.isVisible) {
                            console.warn("Permission denied, logging out...");
                            localStorage.clear();
                            window.location.href = '/';
                            return;
                        }

                        const permissions = permissionResponse.permissions

                        this.context.dispatch({
                            type: "SET_PERMISSION", payload: {
                                permissions
                            },
                        });

                        const userTransactionReport = permissionResponse.permissions.userTransactionReport

                        this.setState({ userTransactionReport }, () => {
                            this.getUserReports();
                        });

                    } else {
                        this.getUserReports();
                    }
                } catch (error) {
                    console.error("Error fetching permissions:", error);
                }
            });
        } catch (error) {
            console.error("Error in componentDidMount:", error);
            localStorage.clear();
            window.location.href = '/';
        }
    }

    public render() {
        const { userTransactionReport } = this.context.state.permissions;
        return (
            <>
                <div className="body-sub-container table-container">
                    <DataGrid
                        title='User Transaction Reports'
                        search='User Details'
                        onFilterChange={(selectedFilter: string, filterValue: string) => {
                            this.setState({
                                selectedFilter,
                                filterValue,
                                currentPage: 1,
                            }, () => this.getUserReports());
                        }}
                        defaultSearch={this.state.searchText}
                        onSearch={(searchText_: string) => {
                            this.setState({
                                searchText: searchText_,
                                currentPage: 1
                            }, () => {
                                this.getUserReports();
                            });
                        }}
                        columns={this.tableColumns}
                        data={this.state.userData}
                        onChangePage={(page: number, totalRows: number) => {
                            this.setState({
                                currentPage: page
                            }, () => {
                                this.getUserReports();
                            })
                        }}
                        onChangeRowsPerPage={(currentRowsPerPage_: number, currentPage_: number) => {
                            this.setState({
                                currentRowsPerPage: currentRowsPerPage_,
                                currentPage: currentPage_
                            }, () => {
                                this.getUserReports();
                            })
                        }}
                        pagination
                        paginationTotalRows={this.state.totalRows}
                        exportCsv={userTransactionReport.isDownloadVisible ? true : false}
                        csvFileName='User Transaction Reports'
                    />
                </div>
                {this.state.showChildComponent && (
                    <LimitHistoryTable
                        accessToken={this.state.accessToken}
                        open={true}
                        selectedUserId={this.state.userID}
                        onClose={() => this.setState({ showChildComponent: false })}
                        isCsvDownload={userTransactionReport.isLimitHistoryDownloadVisible ? true : false}
                    />
                )}
            </>
        )
    }

    private getUserReports() {
        let pageIndex: number = (this.state.currentPage - 1);
        let pagination: any = {
            "pageNumber": pageIndex,
            "recordPerPage": this.state.currentRowsPerPage
        }

        if (this.state.searchText) {
            pagination["searchText"] = this.state.searchText
        }

        if (this.state.selectedFilter) {
            pagination[this.state.selectedFilter] = this.state.filterValue;
        }

        ReportService.getUserReports(this.state.accessToken, pagination).then(tr => {
            if (tr.ok) {
                tr.json().then(resp => {
                    const updatedUserData = resp.userMetricsList.map((user: any) => {
                        const { currencySymbol, currencyEntity, ...userDataWithoutCurrency } = user;
                        return userDataWithoutCurrency;
                    });
                    this.setState({
                        userData: updatedUserData,
                        totalRows: resp.pageCount
                    })
                });
            }
        });
    }

    private openChildComponent(row_: IUserReport, key_: string) {
        this.setState({
            userID: row_.userId,
            showChildComponent: true
        });
    }
}

export default UserReports;